var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.isInfluencer)?_c('AffiliationPreferencesForm'):_vm._e(),_c('MailPreferencesForm'),(_vm.currentUser.isTwitterConnected)?_c('TwitterPreferencesForm'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }